<template>
  <div>
    <Head title="Employees" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      Karyawan
    </h1>
    <div class="flex items-center justify-between mb-6 md:w-1/2">
      <Link class="btn-indigo" href="/employees/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Karyawan</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto md:w-1/2">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Name
            </th>
            <th class="pb-4 pt-6 px-6" colspan="2">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="employee in employees.data"
            :key="employee.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/employees/${employee.id}/edit`"
                tabindex="-1">
                {{ employee.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/employees/${employee.id}/edit`"
                tabindex="-1">
                {{ employee.status }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link
                class="flex items-center px-4"
                :href="`/employees/${employee.id}/edit`"
                tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="employees.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="3">
              No employees found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="employees.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
    },
    layout: Layout,
    props: {
        filters: Object,
        employees: Object,
    },
}
</script>
